import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';

import { showErrorMessage } from '../../util/index';
import Emitter from '../../services/emitter';
import CONSTANT from '../../constant';
import History from '../../util/history';
import Subscribe from '../../util/subscribe';

class PanelBtn extends React.Component {

    constructor(props) {
        super(props);
        const obr = value => {
            console.log('订阅了是否有网络 ', value);
            this.networkStatus = value;
        };
        Subscribe.listen('network', obr);
    }

    handleOpenProjectPanel = () => {
        const { showLoadingPage, saveStatus } = this.props.project;
        if (showLoadingPage || saveStatus === CONSTANT.PROJECT_SAVE_STATUS.DOING) {
            return;
        }
        const { account } = this.props;
        if (this.networkStatus === 'offline') {
            showErrorMessage.bind(this)('MSG.99999');
            return;
        } else if (!account.isLogin) {
            History.replace('/login');
            return;
        }
        Emitter.emit('ClickMenu', 'MENU.SHOW_WEB_PROJECT_PANEL');
    }

    openProjectPanelBtn = () => {
        return (
            <Button
                className="editor-header-project-button"
                onClick={this.handleOpenProjectPanel}>
                <i className={`mblock-icon icon-dakaiwenjian`}></i>
            </Button>
        );
    }

    render() {
        return (
            <section className="header-cell back-menu-cell" title={this.props.intlr.messages['MENU.PROJECTS']}>
                {this.openProjectPanelBtn()}
            </section>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr,
    project: state.project,
    account: state.account
});

export default connect(mapStateToProps)(PanelBtn);